import { ChatMessageBlockType } from 'apps/chat/types/chatMessagesBlockList'

export interface ChatMessageImageSize {
  width: number
  height: number
  size: number
}

export interface ChatMessageReplyBase {
  _mid: string
  sender?: { user_name: string }
  isInsideText: boolean
}

export interface KeyboardItem {
  _oid?: string
  type: string // we need to get enum from backend
  content_id: number
  _content_oid: string
  caption?: string
  url?: string
  actions?: unknown[]
  is_smart_link?: boolean // not sure about that field
}

export enum QuestionAnswerMethod {
  AI_AGENT_INPUT = 'ai_agent_input',
}

export interface InnerMessageTypeQuestion {
  type: ChatMessageBlockType.QUESTION
  caption?: string
  content: {
    text?: string
  }
  answer_method: QuestionAnswerMethod | string
  answer_type: string
  adapters: Array<{
    type: string
    field_id?: number
  }>
  answer_replies: Array<{
    _oid: string
    type: string
    value: unknown
    caption: string
  }>
  limit_failed: number
  question_answer_timeout: {
    unit: string
    value: string
  }
  success_target: {
    content_id: number
    _content_oid: string
  }
  skip_button_caption?: string
  telegram_share_phone_button_caption?: unknown
  validation_message?: string
  _mid?: string
}

export interface InnerMessageTypeOtnRequest {
  type: ChatMessageBlockType.OTN_REQUEST
  keyboard: KeyboardItem[]
  content: {
    one_time_notify_reason_id: number
    one_time_notify_reason_type: string // daily, monthly...
    one_time_notify_reason_caption: string
    text?: string
    image?: {
      type?: ChatMessageBlockType.IMAGE
      caid: number
      img_big: string
      img_small: string
      img_original: string
      title: string
      sign: string
    }
  }
}

interface ImageType {
  caid: number
  img_big: string
  img_small: string
  title: string
  img_original?: string
  sign: string
  image_size: ChatMessageImageSize
  type: 'image'
}

interface RemoteImageType {
  type: 'remote_image'
  url: string
}

export interface CardsElement {
  _oid: string
  type: ChatMessageBlockType.CARD
  keyboard?: KeyboardItem[]
  is_hidden: boolean
  content: {
    title?: string
    subtitle?: string
    image: ImageType | RemoteImageType
  }
}

export interface OtherFormat {
  file: string
  mime: string
  title: string
}
